import { describePath, pushRecent, type QuickPlace, type QuickRecent } from "./search.ts";

/* ──────────────────────────────────────────────────────────────────────────
   Where the person went lately, for the quick bar's rows under the stats.

   Kept in localStorage, which the main window and the quick bar share: they
   are the same site in the same desktop session. It is a convenience, so a
   storage that throws or comes back empty only means no recents.
   ────────────────────────────────────────────────────────────────────────── */

const KEY = "signet.quick.recents";

export function readRecents(): QuickRecent[] {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(KEY) ?? "[]");
    return Array.isArray(parsed)
      ? parsed.filter((r): r is QuickRecent => Boolean(r) && typeof r.to === "string" && r.to.startsWith("/") && typeof r.label === "string")
      : [];
  } catch {
    return [];
  }
}

export function rememberRecent(item: QuickRecent): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(pushRecent(readRecents(), item)));
  } catch {
    // Storage blocked or full: the bar just shows fewer recents.
  }
}

/** A page the main window showed, kept when it is somewhere with a name (a tab, a creator). */
export function rememberVisit(pathname: string, places: QuickPlace[]): void {
  const described = describePath(pathname, places);
  if (described) rememberRecent(described);
}
